import {validation} from './validation';

export default class RequiredValidation {
  constructor(input) {
    const required = input.required === true;
    this.test = validation.create((c) => required ? (c.length > 0) : true).test;
  }
}
